// removed by extract-text-webpack-plugin
module.exports = {"totalHeading":"TransactionsPage--totalHeading--1BGcsDvZ","table":"TransactionsPage--table--mRXwyfb0","cellHeading":"TransactionsPage--cellHeading--3HJzvrJg","cellData":"TransactionsPage--cellData--1mONrMNk","row":"TransactionsPage--row--1DZTeH5A","button":"TransactionsPage--button--38cCP26f"};


//////////////////
// WEBPACK FOOTER
// ./src/App/account/components/TransactionsPage/TransactionsPage.css
// module id = 1288
// module chunks = 2